export default function HighPriorityText() {
  return <p className="lead mt-2 mb-4">Складний рівень</p>;
}
